import { getBackEndVars } from './paypal/getVariables';
import { getValidPromoCode } from './promo-validity-handler';
import { getDiscountFlow } from './discount-flow.js';
export var getPaymentInitialization = function (data, path) {
    if (path === void 0) { path = 'payment-intent'; }
    var url = new window.Url();
    return window.fetcher
        .post(url.build('payments', path), data)
        .then(function (response) {
        return response.data;
    })
        .catch(function (error) {
        if (error.status === 455) {
            url.redirectTo('meal-plan-error');
        }
        else if (error.status === 404) {
            url.redirectTo('/');
        }
        else {
            window.payments.formError.display(data.provider, error.responseJSON.message);
            window.payments.payButton.enable();
            window.payments.applePayButtons.enable();
            window.payments.btnLoader.hide(data.provider);
            window.payments.paymentFormCloseButton.show();
        }
    });
};
export var buildPaymentInitializationPayload = function (data) {
    var _a, _b, _c;
    return {
        purchasable_id: (_a = data.uuid) !== null && _a !== void 0 ? _a : window.getUuid(),
        checkoutOffer: getBackEndVars().checkoutOffer,
        type: getBackEndVars().type,
        provider: data.provider,
        customer_uuid: (_b = data.customer_uuid) !== null && _b !== void 0 ? _b : window.getCustomerUuid(),
        nonce: (_c = data.nonce) !== null && _c !== void 0 ? _c : null,
        promoCode: getValidPromoCode(),
        discountFlow: getDiscountFlow(),
    };
};
